import 'App.css';
import React, { useEffect } from 'react';
import Routes from 'routes/Routes';
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "./redux/data/dataActions";
import { checkConnection } from "./redux/blockchain/blockchainActions";
import { fetchContract } from "./redux/contract/contractAction";


const App = () => {
    const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);

    useEffect(() => {
        if (blockchain.account !== null) {
          dispatch(fetchData(blockchain.account));
        }
        fetchContract();
      }, [dispatch, blockchain.account]);
    useEffect(() => {
        dispatch(fetchContract());
        checkConnection(dispatch)
      }, []);
    return (
        <Routes />
    )
}

export default App;
